import script from "./InputWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./InputWrapper.vue?vue&type=style&index=0&id=1dde57d9&lang=scss"

const __exports__ = script;

export default __exports__